import React, { useEffect, useState } from 'react';
import { useTranslateObject } from '../../hooks/useTranslate';
import { loadClarity } from '../../utils/clarity';
import { isPrerendering } from '../../utils/prerender';
import './CookieConsent.css';

const STORAGE_KEY = 'smartly_cookie_consent';

const CONTENT = {
  title: 'Votre vie privée nous importe',
  text: "Nous utilisons des cookies pour analyser l'usage du site et améliorer votre expérience. Vous pouvez accepter ou refuser ce suivi à tout moment.",
  learnMore: 'Politique de cookies',
  decline: 'Refuser',
  accept: 'Accepter',
};

export default function CookieConsent() {
  const t = useTranslateObject(CONTENT);
  const [visible, setVisible] = useState(false);
  const [entered, setEntered] = useState(false);

  useEffect(() => {
    // Ne jamais figer la bannière (visible) dans le HTML statique pré-rendu — un vrai
    // visiteur démarre toujours son hydration avec visible=false, quel que soit son
    // choix déjà enregistré.
    if (isPrerendering()) return;

    const stored = window.localStorage.getItem(STORAGE_KEY);

    if (stored === 'accepted') {
      loadClarity();
      return;
    }

    if (stored === 'declined') {
      return;
    }

    setVisible(true);
    const timer = window.setTimeout(() => setEntered(true), 50);
    return () => window.clearTimeout(timer);
  }, []);

  const handleChoice = (choice) => {
    window.localStorage.setItem(STORAGE_KEY, choice);
    if (choice === 'accepted') {
      loadClarity();
    }
    setEntered(false);
    window.setTimeout(() => setVisible(false), 250);
  };

  if (!visible) return null;

  return (
    <div className={`cookie-consent${entered ? ' cookie-consent--visible' : ''}`} role="dialog" aria-live="polite" aria-label={t.title}>
      <div className="cookie-consent__icon" aria-hidden="true">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21.5 12.5c-1.5 0-2.5-1-2.5-2.5" />
          <path d="M12 2a10 10 0 1 0 9.95 11 8.5 8.5 0 0 1-9.95-11z" />
          <circle cx="8.5" cy="10.5" r="1.2" fill="currentColor" stroke="none" />
          <circle cx="12" cy="15.5" r="1.2" fill="currentColor" stroke="none" />
          <circle cx="8" cy="15" r="0.8" fill="currentColor" stroke="none" />
        </svg>
      </div>

      <div className="cookie-consent__body">
        <p className="cookie-consent__title">{t.title}</p>
        <p className="cookie-consent__text">
          {t.text}{' '}
          <a href="/legal-docs/cookies" className="cookie-consent__link">{t.learnMore}</a>
        </p>

        <div className="cookie-consent__actions">
          <button type="button" className="cookie-consent__btn cookie-consent__btn--ghost" onClick={() => handleChoice('declined')}>
            {t.decline}
          </button>
          <button type="button" className="cookie-consent__btn cookie-consent__btn--primary" onClick={() => handleChoice('accepted')}>
            {t.accept}
          </button>
        </div>
      </div>
    </div>
  );
}
